<template>
  <el-dialog
    :title="'Тайлбар'"
    :visible.sync="isShow"
    @close="mCloseFunction"
    @closed="mCloseFunction"
    :before-close="mCloseFunction"
    :close-on-click-modal="isOpenDialog"
    width="35%"
    v-if="explainValue"
  >
      <div class="seeDesc">
        <el-table :data="explainValue" >
          <el-table-column prop="description" label="Тайлбар" width="315">
          </el-table-column>
          <el-table-column prop="files" label="Файл" width="315">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.files" :key="index">
                    <a
                      style="text-decoration: revert; color: #1E59F8"
                      :href="item.path"
                      target="blank"
                      >{{ item.name }}
                      </a
                    >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mCloseFunction" type="primary"
          >Болсон</el-button
        >
      </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'ExplainDialog',
  props: {
    isShow: Boolean,
    closeFunction: Function,
    explainValue: Array
  },
  data () {
    return {
      isOpenDialog: false,
      zoruu_dun: 0,
      desc: '',
      explain: []
    }
  },
  created () {
    this.explain = [this.explainValue]
  },
  methods: {
    mCloseFunction () {
      this.closeFunction()
    }
  }
}
</script>
<style>
  .seeDesc .el-table td {
    cursor: default !important;
  }
  </style>
